import { AppImages } from "app/appImages";
import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

export type UserAutoCompleteQueryParams = {
    pageNumber: number;
    pageSize: number;
    searchText?: string | null;
};

interface IProps {
    onGetDataCustom?: (data: UserAutoCompleteQueryParams, signal: GenericAbortSignal | undefined) => Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>;
}

type Props = IProps & Omit<IAutoCompleteProps, 'onGetSuggestions' | 'emptyThumbnail'>;

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de usuários
 * @param props
 */
export const AuthorAutoComplete: React.FC<Props> = (props) => {

    const api = useCoreApi();
    const { onError, onGetDataCustom } = props;

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        if (onGetDataCustom != undefined) {
            return onGetDataCustom({ pageNumber, pageSize, searchText }, signal);
        } else {
            return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
                api.v1.knowledgeSuggestions.publicationAuthors({
                    searchText: searchText,
                    pageNumber: pageNumber,
                    pageSize: pageSize,
                }, { signal })
                    .then(result => {
                        resolve({
                            items: result.data.items as AutoCompleteDataModel[],
                            totalRows: result.data.totalRows
                        });
                    })
                    .catch(error => {
                        if (!isCanceledError(error)) {
                            resolve({ items: [], totalRows: 0 });
                            if (onError) onError(error);
                        }
                    });
            });
        }
    };

    const handleChange = (items: AutoCompleteDataModel[]) => {
        props.onChange(items);
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onChange={handleChange}
            emptyThumbnail={AppImages.UserThumbnail}
            onGetSuggestions={getSuggestions}
        />
    );
};
